export default __webpack_public_path__ + "297bcf6a42536823e10af2aa64710b99.ogg";